const IconProfileUser = ({
  fill = '#171A1A',
  className,
  dataTestid = 'profile-user'
}) => (
  <svg
    className={className}
    data-testid={dataTestid}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2453_1358"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="17"
    >
      <rect
        className={`${className}-rect`}
        data-testid={`${dataTestid}-rect`}
        x="0.736328"
        y="0.342285"
        width="16"
        height="16"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_2453_1358)">
      <path
        className={`${className}-path`}
        data-testid={`${dataTestid}-path`}
        d="M1.40283 13.6756V11.809C1.40283 11.4312 1.50005 11.084 1.6945 10.7673C1.88894 10.4506 2.14728 10.209 2.4695 10.0423C3.15839 9.69786 3.85839 9.43953 4.5695 9.26731C5.28061 9.09508 6.00283 9.00897 6.73617 9.00897C7.4695 9.00897 8.19172 9.09508 8.90283 9.26731C9.61394 9.43953 10.3139 9.69786 11.0028 10.0423C11.3251 10.209 11.5834 10.4506 11.7778 10.7673C11.9723 11.084 12.0695 11.4312 12.0695 11.809V13.6756H1.40283ZM13.4028 13.6756V11.6756C13.4028 11.1868 13.2667 10.7173 12.9945 10.2673C12.7223 9.81731 12.3362 9.43119 11.8362 9.10897C12.4028 9.17564 12.9362 9.28953 13.4362 9.45064C13.9362 9.61175 14.4028 9.80897 14.8362 10.0423C15.2362 10.2645 15.5417 10.5118 15.7528 10.784C15.9639 11.0562 16.0695 11.3534 16.0695 11.6756V13.6756H13.4028ZM6.73617 8.34231C6.00283 8.34231 5.37505 8.08119 4.85283 7.55897C4.33061 7.03675 4.0695 6.40897 4.0695 5.67564C4.0695 4.94231 4.33061 4.31453 4.85283 3.79231C5.37505 3.27008 6.00283 3.00897 6.73617 3.00897C7.4695 3.00897 8.09728 3.27008 8.6195 3.79231C9.14172 4.31453 9.40283 4.94231 9.40283 5.67564C9.40283 6.40897 9.14172 7.03675 8.6195 7.55897C8.09728 8.08119 7.4695 8.34231 6.73617 8.34231ZM13.4028 5.67564C13.4028 6.40897 13.1417 7.03675 12.6195 7.55897C12.0973 8.08119 11.4695 8.34231 10.7362 8.34231C10.6139 8.34231 10.4584 8.32842 10.2695 8.30064C10.0806 8.27286 9.92505 8.24231 9.80283 8.20897C10.1028 7.85342 10.3334 7.45897 10.4945 7.02564C10.6556 6.59231 10.7362 6.14231 10.7362 5.67564C10.7362 5.20897 10.6556 4.75897 10.4945 4.32564C10.3334 3.89231 10.1028 3.49786 9.80283 3.14231C9.95839 3.08675 10.1139 3.05064 10.2695 3.03397C10.4251 3.01731 10.5806 3.00897 10.7362 3.00897C11.4695 3.00897 12.0973 3.27008 12.6195 3.79231C13.1417 4.31453 13.4028 4.94231 13.4028 5.67564ZM2.73617 12.3423H10.7362V11.809C10.7362 11.6868 10.7056 11.5756 10.6445 11.4756C10.5834 11.3756 10.5028 11.2979 10.4028 11.2423C9.80283 10.9423 9.19728 10.7173 8.58617 10.5673C7.97505 10.4173 7.35839 10.3423 6.73617 10.3423C6.11394 10.3423 5.49728 10.4173 4.88617 10.5673C4.27505 10.7173 3.6695 10.9423 3.0695 11.2423C2.9695 11.2979 2.88894 11.3756 2.82783 11.4756C2.76672 11.5756 2.73617 11.6868 2.73617 11.809V12.3423ZM6.73617 7.00897C7.10283 7.00897 7.41672 6.87842 7.67783 6.61731C7.93894 6.35619 8.0695 6.04231 8.0695 5.67564C8.0695 5.30897 7.93894 4.99508 7.67783 4.73397C7.41672 4.47286 7.10283 4.34231 6.73617 4.34231C6.3695 4.34231 6.05561 4.47286 5.7945 4.73397C5.53339 4.99508 5.40283 5.30897 5.40283 5.67564C5.40283 6.04231 5.53339 6.35619 5.7945 6.61731C6.05561 6.87842 6.3695 7.00897 6.73617 7.00897Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default IconProfileUser;
